import { WEB_COMPONENT_EASM_SIDE_MENU } from '../../webcomponents.constants';
import { GzEASMSideMenuWebComponent } from './component/GzEASMSideMenuWebComponent';
export { GzEASMSideMenuWebComponent };
window.customElements.define(WEB_COMPONENT_EASM_SIDE_MENU, GzEASMSideMenuWebComponent);
